import { useNetwork } from "~/config/capacitor/network/hook";

const useIsOffline = () => useNetwork().isOffline;

export { useIsOffline };
